import _ from 'lodash'
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()


export class ParticipantsGroup {
  constructor(item) {
    this.organizationId = item.organizationId || 0
    this.organizationUsreou = item.organizationUsreou ||  item.usreou
    this.organizationTitle = item.organizationTitle
    this.supplierRatings = item.supplierRatings || item.rating
    if ( item.groupId ) {
      this.groupId = item.groupId
      this.groupName = item.groupName
    }
    this.expanded = false
    this.draft = false || item.draft
    this.participationCount = item.users?.length 
      ? item.users.reduce((sum, currentValue) => sum + currentValue.participationCount, 0) 
      : ''
    if (item.users) {
      this.users = _.map(item.users, user => new ParticipantUser({
        ...user,
        organizationId: this.organizationId,
        organizationUsreou: this.organizationUsreou,
        organizationTitle: this.organizationTitle,
        supplierRatings: this.supplierRatings
      }))
    } else {
      this.users = [new ParticipantUser(Object.assign(item))]
    }
  }

  get selected() {
    let ret = !!this.users.length && this.users.every(i => i.selected)
    return ret
  }
  set selected(val) {
    this.users.forEach(u => u.selected = val)
  }
  get indeterminated() {
    let ret = !!this.users.length && this.users.some(i => i.selected) && this.users.some(i => !i.selected)
    return ret
  }
  get count() {
    return this.users.length
  }

  static MyGroup(users) {
    let first = users[0]
    return new ParticipantsGroup({
      organizationId: first.organizationId || 0,
      organizationUsreou: first.organizationUsreou,
      organizationTitle: first.organizationTitle,
      supplierRatings: first.supplierRatings,
      users,
      expanded: false,
    })
  }

  static Draft(capt) {
    return new ParticipantsGroup({
      organizationId: -1,
      organizationUsreou: '',
      organizationTitle: capt,
      participationCount: 0,
      supplierRatings: 0,
      users: [],
      expanded: false,
      draft: true
    })
  }
}

export class ParticipantUsers {

  constructor(items) {
    this.users = {}
    if (items) {
      this.users = _.chain(items)
        .map(item => item instanceof ParticipantUser ? item : new ParticipantUser(item))
        .keyBy('email')
        .value()
    }
  }

  /**
  * @param {ParticipantUser} item
  */
  push(item) {
    this.users[item.email.toUpperCase()] = item
  }

  get all() {
    return Object.values(this.users)
  }

  get count() {
    return this.users.length
  }

  async checkRegistrations() {
    let that = this
    if (that.all == null || that.all.length == 0) {
      return
    }
    await tender_api.getParticipants(that.all.map(i => i.email))
      .then((resp) => {
        const users = resp?.users || []
        const rejected = resp?.rejected || []
        Object.values(this.users).forEach((user) => {
          const email = user.email.toUpperCase()
          const existUser = users.find(i => i.userEmail.toUpperCase() === email)
          user.fillRegistrationData(existUser)
          const rejection = rejected.find(i => i.email?.toUpperCase() === email)
          if (rejection) {
            user.invalid = true
            user.invalidReason = rejection.reason
            user.suggestion = rejection.suggestion || ''
          }
        })
      })
  }
}

export class ParticipantUser {
  constructor(item) {
    this.contactId = item.contactId
    this.organizationTitle = item.organizationTitle,
    this.organizationUsreou = item.organizationUsreou,
    this.organizationId = item.organizationId || 0,
    this.email = item.email?.replace('\r', '')?.replace('\n', '')?.trim(),
    this.userName = item.name || item.userName,
    this.participationCount = item.participationCount,
    this.supplierRatings = item.supplierRatings,
    this.selected = false || item.selected
    this.manualAdded = false || item.manualAdded
    this.remark = item.remark
    this.not_registered = false
    this.invalid = false // set by ParticipantUsers.checkRegistrations from the lookup rejections
    this.invalidReason = ''
    this.suggestion = ''
    this.uniqId = `${item.contactId || 0}_${this.email || 0}_${this.userName || 0}`
  }

  get emptyData() {
    return '–'
  }
  get userConcatNameEmail() {
    return ''.concat(this.organizationTitle,this.organizationId,this.email,this.userName)
  }
  static InviteParticipantUser(email, name) {
    return new ParticipantUser({ 
      email: email.replace('\r', '').replace('\n', '').trim(),
      userName: name || '',
      selected: true,
      manualAdded: true
    })
  }
  fillRegistrationData(resp) {
    this.not_registered = !resp
    this.organizationTitle = resp?.organizationTitle || ''
    this.organizationUsreou = resp?.organizationUsreou || ''
    this.organizationId = resp?.organizationId || this.organizationId || 0 //|| resp?.organizationUsreou 
    this.userName = resp?.userName ||  this.userName //|| that.email
    this.manualAdded = this.manualAdded || !resp
  }
  // async checkRegistration() {
  //   let that = this
  //   await tender_api.getParticipants(this.emails)
  //     .then((resp) => {
  //       that.not_registered = !resp
  //       that.organizationTitle = resp?.organizationTitle || ''
  //       that.organizationUsreou = resp?.organizationUsreou || ''
  //       that.organizationId = resp?.organizationId || that.organizationId || 0 //|| resp?.organizationUsreou 
  //       that.userName = resp?.userName ||  that.userName //|| that.email
  //       that.manualAdded = that.manualAdded || !resp
  //     })
  // }
}
export class OrganizationsGroup {
  constructor(item) {
    this.id = item.id
    this.groupName = item.groupName
    this.groupId = item.groupId
    this.expanded = false
    this.organisations = _.map(item.organisations, org => new ParticipantsGroup(Object.assign(org, this)))
  }

  get emptyData() {
    return '–'
  }
  get selected() {
    let ret = !!this.organisations.length && this.organisations.every(i => i.selected ) 
    return ret
  }
  set selected(val) {
    this.organisations.forEach(u => u.selected = val)
  }
  get indeterminated() {
    let ret = !!this.organisations.length && this.organisations.some(i => i.selected || i.indeterminated)
      && this.organisations.some(i => !i.selected || !i.indeterminated)
      && !this.organisations.every(i => i.selected ) 
    return ret
  }
  get count() {
    return this.organisations.reduce((total, group) =>  total.concat(group.users) , []).length
  }
}